module.exports = __webpack_public_path__ + "static/visa-deals-0eec6fd246cfe46d2779aa6a45edba2b.png";